import { EmployerVacancyTemplateFilter, AllowedCriteria } from 'src/models/employerVacancyTemplateFilter';

export const getTemplateCriteria = (templateFilter: EmployerVacancyTemplateFilter): AllowedCriteria[] | undefined => {
    const hiddenFilters = Object.keys(templateFilter);
    return hiddenFilters.length ? hiddenFilters : undefined;
};
